import { Site, memoize, setTimeFromString } from '@jucy-ui/common';
import { getDefaultTimes } from './getDefaultTimes';

export const getDefaultDropOffTime = memoize(({ date, branch }: { date: Date; branch?: Site }) => {
    const time = getDefaultTimes({ date, branch }).dropOff || '10:00';
    return setTimeFromString(date, time);
});
